import React, { useState, useEffect } from 'react';
import StripeService from '../services/StripeService';
import DisButton from './design-system/DisButton';

const StripePaymentForm = ({ clientSecret, planId, onSuccess, onCancel }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [stripeLoaded, setStripeLoaded] = useState(false);
  const [cardElement, setCardElement] = useState(null);
  
  const stripeService = StripeService.getInstance();

  useEffect(() => {
    if (clientSecret) {
      initializeStripe();
    }
  }, [clientSecret]);

  const initializeStripe = async () => {
    try {
      await stripeService.initialize();
      setStripeLoaded(true);
      
      // Créer l'élément de carte après un court délai
      setTimeout(() => {
        const cardContainer = document.getElementById('stripe-card-element');
        if (cardContainer) {
          const card = stripeService.createCardElement(cardContainer);
          setCardElement(card);
        }
      }, 100);
    } catch (error) {
      console.error('Erreur d\'initialisation Stripe:', error);
    }
  };

  const handlePayment = async () => {
    if (!stripeLoaded || !cardElement || !clientSecret) {
      alert('Service de paiement non disponible');
      return;
    }

    setIsProcessing(true);

    try {
      const result = await stripeService.confirmPayment(clientSecret);

      if (result.success) {
        onSuccess();
      } else {
        alert(`❌ Erreur de paiement: ${result.error || 'Erreur de paiement'}`);
      }

    } catch (error) {
      console.error('Erreur de paiement:', error);
      alert('❌ Erreur technique lors du paiement');
    } finally {
      setIsProcessing(false);
    }
  };

  if (!stripeLoaded) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Chargement du service de paiement...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Formulaire de carte */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          💳 Informations de paiement
        </label>
        <div 
          id="stripe-card-element"
          className="p-3 border border-gray-300 rounded-lg bg-white"
          style={{ minHeight: '40px' }}
        />
      </div>

      {/* Actions */}
      <div className="flex space-x-4">
        <DisButton
          variant="secondary"
          onClick={onCancel}
          disabled={isProcessing}
          className="flex-1"
        >
          Annuler
        </DisButton>

        <DisButton
          variant="primary"
          onClick={handlePayment}
          disabled={isProcessing}
          className="flex-2"
        >
          {isProcessing ? 'Traitement...' : 'Confirmer le paiement'}
        </DisButton>
      </div>

      <p className="text-xs text-gray-500 text-center">
        🔒 Paiement sécurisé par Stripe • Annulation possible à tout moment
      </p>
    </div>
  );
};

export default StripePaymentForm;